import { PensionPlanTransfer } from '../api/pension-plan-transfers/interfaces/PensionPlanTransfer';
import { ArcaPlan, findArcaPlanById, findArcaPlanByName } from '../constants/arcaPlans';

/**
 * Selecciona el traspaso que representa el plan ACTIVO del usuario.
 * Mismo criterio que la vista de Inicio (`transferForPlan`): el completado y,
 * si no hay, el "primario" (solicitado/borrador → en curso → completado → primero).
 *
 * Fuente única para que Inicio y el simulador resuelvan el MISMO plan.
 */
export function resolveActiveTransfer(
	transfers: PensionPlanTransfer[] | undefined
): PensionPlanTransfer | undefined {
	if (!transfers || transfers.length === 0) return undefined;
	const completed = transfers.find((t) => t.status === 'completed');
	const primary =
		transfers.find((t) => t.status === 'requested' || t.status === 'draft') ??
		transfers.find((t) => t.status === 'in_progress') ??
		completed ??
		transfers[0];
	return completed ?? primary;
}

/** Resuelve el ArcaPlan de un traspaso (por id seleccionado o, en su defecto, por nombre). */
export function arcaPlanFromTransfer(
	transfer: PensionPlanTransfer | undefined
): ArcaPlan | undefined {
	if (!transfer) return undefined;
	return transfer.selectedArcaPlanId
		? findArcaPlanById(transfer.selectedArcaPlanId)
		: findArcaPlanByName(transfer.metadata?.plan_name ?? '');
}

/** ArcaPlan del plan activo del usuario a partir de su lista de traspasos. */
export function resolveActiveArcaPlan(
	transfers: PensionPlanTransfer[] | undefined
): ArcaPlan | undefined {
	return arcaPlanFromTransfer(resolveActiveTransfer(transfers));
}
